import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Watch = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M13 8h-2v5h5v-2h-3z", key: "k0" }),
        React.createElement("path", { d: "M16 5.084V2H8v3.083C5.613 6.469 4.001 9.047 4.001 12a8.003 8.003 0 0 0 4.136 7H8v3.041h8V19h-.138a8.002 8.002 0 0 0 4.137-7c0-2.953-1.612-5.53-3.999-6.916zm-4.001 12.915c-3.307 0-5.998-2.691-5.998-5.999s2.691-5.999 5.998-5.999c3.309 0 6 2.691 6 5.999s-2.691 5.999-6 5.999z", key: "k1" })));
});
Watch.displayName = 'Watch';
export var WatchDimensions = { height: 24, width: 24 };
